import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/careers/CareersClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
